export const RESTRICCIONES_DE_AUDIO: MediaTrackConstraints = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};

export async function abrirMicrofono(): Promise<MediaStream> {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw Object.assign(new Error('getUserMedia no está disponible.'), { name: 'SecurityError' });
  }
  return navigator.mediaDevices.getUserMedia({ audio: RESTRICCIONES_DE_AUDIO, video: false });
}

export const cerrarMicrofono = (microfono: MediaStream): void => {
  microfono.getTracks().forEach((pista) => pista.stop());
};
